//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
import { Toast, Overlay} from 'vant';
// import { Toast, PullRefresh,Empty} from 'vant';




export default {
  name: "companyDetails",
  data() {
    let that = this;
    return {
      showD:false,
      pageSizeSel: 9,//分页条数
      companyReleaseInfo: {},//企业发布信息
      twoProdTypeList: null,//标准件 二级分类list
      threeProdTypeList: null,//标准件  三级分类list
      companyType: "",//企业所属行业   //00001广告字招牌生产   00002标识导视生产   00003展示道具生产：展架    00004原材料耗材生产：云商    00005广告店铺：广告店铺
      companyId: "",//上个页面传进来的参数
      companyName: "",//企业名称
      checkDetailTitle: 1,//二级类目选中的是哪个选项卡
      checkSysProdType: "-1",//产品方案选中的是哪个分类选项
      prodInfoList: null,//当前显示的产品信息list
      loadProdInfoName: "加载更多",//产品底部加载更多按钮名称
      canSelProdInfo: true,//是否还能点击加载更多产品方案  true可以，false已经全显示完了
      loadProdCaseName: "加载更多",//产品方案底部加载更多按钮名称  
      canSelProdCase: true,//是否还能点击加载更多产品方案  true可以，false已经全显示完了
      releaseProdCaseList: null,//当前显示的产品方案list


      checkCjhjType: "全部",//厂家环境选中的是哪个分类选项
      checkCjhj: null,//厂家环境选中的分类对象（含该分类下所有图片信息）
      xmpcCpal: null,//产品方案：含list、分页、分类信息

      xmpcCpalSelObj: {},//产品方案搜索对象
      xmgeBzjcpSelObj: {},//标准件产品搜索对象
      checkSelProdTypeId: "-1",//所选择的标准件产品 分类id
      checkOneProdType: "-1",//所选择的标准件产品 分类id  第1级
      checkTwoProdType: "-1",//所选择的标准件产品 分类id  第2级
      checkThreeProdType: "-1",//所选择的标准件产品 分类id  第3级
      
      canSelProdInfo: true,//是否还能点击加载更多产品  true可以，false已经全显示完了
      isFollow: 0,//是否关注了该企业 0否 1是
      ucFollowCompany: null,//关注该企业的信息
      userId: null,//当前登录的用户id
      showImall: false,
      swiperOptionTop: {
        loop: false,
        loopedSlides: 5,
        spaceBetween: 10,
        touchRatio: 0,
      },
      swiperOptionThumbs: {
        loop: false,
        loopedSlides: 5,
        spaceBetween: 10,
        centeredSlides: false,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
        on: {
          tap(event) {
            that.swiper.slideTo(that.swiperThumbsBot.clickedIndex, 1000, false); 
          },
        },
      },
      swiperOptionTopF: {
        loop: false,
        loopedSlides: 5,
        spaceBetween: 10,
        touchRatio: 0,
        navigation:{
          prevEl:'.swiper-button-prev',
          nextEl:'.swiper-button-next',
        },
        pagination: {
          el: '.swiper-pagination',
          type: ''
        },
        observer: true,
        observeParents: true,
      },
      swiperOptionThumbsF: {
        loop: false,
        loopedSlides: 5,
        spaceBetween: 10,
        centeredSlides: false,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
        on: {
          tap(event) {
            that.swiperF.slideTo(that.swiperFA.clickedIndex, 1000, false);
          },
        },
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    Overlay,
    Header,
    Footer,
  },
  directives: {
    swiper: directive,
  },
  computed: {
    swiper() {
      return this.$refs.swiperTop.$swiper;
    },
    swiperThumbsBot() {
      return this.$refs.swiperThumbs.$swiper;
    },
    swiperF() {
      return this.$refs.swiperTopF.$swiper;
    },
    swiperFA() {
      return this.$refs.swiperThumbsF.$swiper;
    },

  },
  methods: {
    getEchartData(obj) {
            let myChart = this.$echarts.init(document.getElementById(obj.id))
            var dataname = obj.name
            var datamax = obj.arr
            var datavaule = obj.arr1
            var datavauleS =  obj.arr2
            var datavauleD =  obj.arr3
            var indicator = []
            for (var i = 0; i < dataname.length; i++) {
                indicator.push({
                    name: dataname[i],
                    max: datamax[i],
                })
            }
          function contains(arrays, obj) {
              var i = arrays.length;
              while (i--) {
                  if (arrays[i] === obj) {
                      return i;
                  }
              }
              return false;
          }
          let  option = {
              tooltip: {
                  show: false,
                  trigger: "item",
                  formatter:function(params){
                   return params.value
                 }
              },
              radar: [
                {
                  center: ["28%", "50%"],
                  radius: "65%",
                  startAngle: 240,
                  splitNumber: 5,
                  splitArea: {
                      areaStyle: {
            "color": [
                    "#0100bd",
                    "#3434ca",
                    "#5d5cd4"
                ]
                      }
                  },
                  axisLabel: {
                      show: false,
                  },
                  axisLine: {
                      show: true,
                      lineStyle: {
                          color: "transparent"
                      }
                  },
                  splitLine: {
                      show: true,
                      lineStyle: {
                          color: "transparent"
                      }
                  },
                  name: {
                      formatter:function(value){
                    var i = contains(dataname, value);
                          var percent = datavaule[i];
                  var ret = "";
                  var maxLength = 4;
                  var valLength = value.length;
                  var rowN = Math.ceil(valLength / maxLength); 
                  if (rowN > 1)
                  {  
                    var temp = "";
                    var start = 0;
                    var end = maxLength;
                    temp = value.substring(start, end)+'\n'+value.substring(end, valLength)					
                    ret += temp; 
                    return '{a|' + percent + '}\n' + '{b|' + ret + '}'
                  }
                  else{
                    return '{a|' + percent + '}\n' + '{b|' + value + '}'
                  }
                },
                      textStyle: {
                  rich: {
                              a: {
                                  color: '#FFFFFF',
                      fontSize: 15,
                      padding: [0, 0],
                      lineHeight:20,
                              },
                              b: {
                                  color: '#394291',
                      fontSize: 15,
                      padding: [0, 0],
                      lineHeight:20,
                              }
                          },
                      },
                  },
                  indicator: indicator
              }],
              series: [
                {
                  type: "radar",
                  symbol: "circle",
                  symbolSize: 7,
                  areaStyle: {
                      normal: {
                          color: 'rgba(170, 216, 255, 0)',
                      }
                  },
                  itemStyle: {
                      color: '#eddf00',
                      borderColor: '#eddf00',
                      borderWidth: 1,
                  },
                  lineStyle: {
                      normal: {
                          color: "#eddf00",
                          width: 1
                      }
                  },
                  data: [datavaule]
              },
                {
                  type: "radar",
                  symbol: "circle",
                  symbolSize: 7,
                  areaStyle: {
                      normal: {
                          color: 'rgba(170, 216, 255, 0)',
                      }
                  },
                  itemStyle: {
                      color: '#e3a164',
                      borderColor: '#e3a164',
                      borderWidth: 1,
                  },
                  lineStyle: {
                   normal: {
                        color: "#e3a164",
                        width: 1,
                        type: "dashed"
                    }
                  },
                  data: [datavauleS]
              },
                {
                  type: "radar",
                  symbol: "circle",
                  symbolSize: 7,
                  areaStyle: {
                      normal: {
                          color: 'rgba(170, 216, 255, 0)',
                      }
                  },
                  itemStyle: {
                      color: '#8ec31d',
                      borderColor: '#8ec31d',
                      borderWidth: 1,
                  },
                  lineStyle: {
                   normal: {
                        color: "#8ec31d",
                        width: 1,
                        type: "dashed"
                    }
                  },
                  data: [datavauleD]
              }
              ]
            };
        myChart.setOption(option);
    },
    getEchartDataTwo(obj) {
            let myChart = this.$echarts.init(document.getElementById(obj.id))
            var dataname = obj.name
            var datamax = obj.arr
            var datavaule = obj.arr1
            var datavauleS =  obj.arr2
            var datavauleD =  obj.arr3
            var indicator = []
            for (var i = 0; i < dataname.length; i++) {
                indicator.push({
                    name: dataname[i],
                    max: datamax[i],
                })
            }
          function contains(arrays, obj) {
              var i = arrays.length;
              while (i--) {
                  if (arrays[i] === obj) {
                      return i;
                  }
              }
              return false;
          }
          let  option = {
              tooltip: {
                 show:false,
                 trigger: 'item',
                 formatter:function(params){
                   return params.value
                 }
              },
              radar: [
                {
                  center: ["28%", "50%"],
                  radius: "65%",
                  startAngle: 240,
                  splitNumber: 5,
                  splitArea: {
                      areaStyle: {
            "color": [
                    "#0100bd",
                    "#3434ca",
                    "#5d5cd4"
                ]
                      }
                  },
                  axisLabel: {
                      show: false,
                  },
                  axisLine: {
                      show: true,
                      lineStyle: {
                          color: "transparent"
                      }
                  },
                  splitLine: {
                      show: true,
                      lineStyle: {
                          color: "transparent"
                      }
                  },
                  name: {
                      formatter:function(value){
                    var i = contains(dataname, value);
                          var percent = datavaule[i];
                  var ret = "";
                  var maxLength = 4;
                  var valLength = value.length;
                  var rowN = Math.ceil(valLength / maxLength); 
                  if (rowN > 1)
                  {  
                    var temp = "";
                    var start = 0;
                    var end = maxLength;
                    temp = value.substring(start, end)+'\n'+value.substring(end, valLength)					
                    ret += temp; 
                    return '{a|' + percent + '}\n' + '{b|' + ret + '}'
                  }
                  else{
                    return '{a|' + percent + '}\n' + '{b|' + value + '}'
                  }
                },
                      textStyle: {
                  rich: {
                              a: {
                                  color: '#FFFFFF',
                      fontSize: 15,
                      padding: [0, 0],
                      lineHeight:20,
                              },
                              b: {
                                  color: '#394291',
                      fontSize: 15,
                      padding: [0, 0],
                      lineHeight:20,
                              }
                          },
                      },
                  },
                  indicator: indicator
              }],
              series: [
                {
                  type: "radar",
                  symbol: "circle",
                  symbolSize: 7,
                  areaStyle: {
                      normal: {
                          color: 'rgba(170, 216, 255, 0)',
                      }
                  },
                  itemStyle: {
                      color: '#eddf00',
                      borderColor: '#eddf00',
                      borderWidth: 1,
                  },
                  lineStyle: {
                      normal: {
                          color: "#eddf00",
                          width: 1
                      }
                  },
                  data: [datavaule]
              },
                {
                  type: "radar",
                  symbol: "circle",
                  symbolSize: 7,
                  areaStyle: {
                      normal: {
                          color: 'rgba(170, 216, 255, 0)',
                      }
                  },
                  itemStyle: {
                      color: '#e3a164',
                      borderColor: '#e3a164',
                      borderWidth: 1,
                  },
                  lineStyle: {
                   normal: {
                        color: "#e3a164",
                        width: 1,
                        type: "dashed"
                    }
                  },
                  data: [datavauleS]
              },
                {
                  type: "radar",
                  symbol: "circle",
                  symbolSize: 7,
                  areaStyle: {
                      normal: {
                          color: 'rgba(170, 216, 255, 0)',
                      }
                  },
                  itemStyle: {
                      color: '#8ec31d',
                      borderColor: '#8ec31d',
                      borderWidth: 1,
                  },
                  lineStyle: {
                   normal: {
                        color: "#8ec31d",
                        width: 1,
                        type: "dashed"
                    }
                  },
                  data: [datavauleD]
              }
              ]
            };
        myChart.setOption(option);
    },
    getEchartDataline(obj){
        let myChart = this.$echarts.init(document.getElementById(obj.id))
        let dataX = ['1K以下','1~2K','2~3K','3~5K','5~10K','10~20K','20~30K','30~40K','40K以上']
       let  option = {
    title: {
        textStyle: {
            align: 'center',
            color: '#fff',
            fontSize: 20,
        },
        top: '5%',
        left: 'center',
    },
    tooltip: {
        trigger: 'axis',
    },
    grid: {
        top: '15%',
        left: '5%',
        right: '5%',
        bottom: '15%',
    },
    xAxis: [{
        type: 'category',
        axisLine: {
            show: true
        },
        splitArea: {
            color: '#676767',
            lineStyle: {
                color: '#676767'
            },
        },
        axisLabel: {
            color: '#676767'
        },
        splitLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        boundaryGap: false,
        data: dataX,

    }],

    yAxis: [{
        type: 'value',
        min: 0,
        splitNumber: 4,
        splitLine: {
            show: true,
            lineStyle: {
                color: 'rgba(255,255,255,0.1)'
            }
        },
        axisLine: {
            show: true,
        },
        axisLabel: {
            show: false,
            margin: 20,
            textStyle: {
                color: '#d1e6eb',

            },
        },
        axisTick: {
            show: false,
        },
    }],
    series: [{
            name: '单品生产交付',
            type: 'line',
            smooth: true, 
            showAllSymbol: true,
            symbol: 'circle',
            symbolSize: 15,
            lineStyle: {
                normal: {
                    color: "#362eb7",
                    shadowColor: 'rgba(0, 0, 0, .3)',
                    shadowBlur: 0,
                    shadowOffsetY: 5,
                    shadowOffsetX: 5,
                },
            },
            label: {
                show: false,
            },
            itemStyle: {
                color: "#fff",
                borderColor: "#362eb7",
                borderWidth: 1,
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 0,
                shadowOffsetY: 0,
                shadowOffsetX: 0,
            },
            areaStyle: {
                normal: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(45,38,170,0.3)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(45,38,170,0)'
                        }
                    ], false),
                    shadowColor: 'rgba(45,38,170,0.9)',
                    shadowBlur: 20
                }
            },
            data: obj.arr
        },
        {
            name: '综合交付',
            type: 'line',
            smooth: true, 
            showAllSymbol: true,
            symbol: 'circle',
            symbolSize: 15,
            lineStyle: {
                normal: {
                    color: "#e5a05d",
                    shadowColor: 'rgba(0, 0, 0, .3)',
                    shadowBlur: 0,
                    shadowOffsetY: 5,
                    shadowOffsetX: 5,
                },
            },
            label: {
                show: false,
            },

            itemStyle: {
                color: "#fff",
                borderColor: "#e5a05d",
                borderWidth: 1,
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 0,
                shadowOffsetY: 0,
                shadowOffsetX: 0,
            },
            areaStyle: {
                normal: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(229,160,93,0.3)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(229,160,93,0)'
                        }
                    ], false),
                    shadowColor: 'rgba(229,160,93, 0.9)',
                    shadowBlur: 20
                }
            },
            data: obj.arr2,
        },
        {
            name: '平台方案交付',
            type: 'line',
            smooth: true, 
            showAllSymbol: true,
            symbol: 'circle',
            symbolSize: 15,
            lineStyle: {
                normal: {
                    color: "#90c31e",
                    shadowColor: 'rgba(0, 0, 0, .3)',
                    shadowBlur: 0,
                    shadowOffsetY: 5,
                    shadowOffsetX: 5,
                },
            },
            label: {
                show: false,
            },

            itemStyle: {
                color: "#fff",
                borderColor: "#90c31e",
                borderWidth: 1,
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 0,
                shadowOffsetY: 0,
                shadowOffsetX: 0,
            },
            areaStyle: {
                normal: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(144,195,30,0.3)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(144,195,30,0)'
                        }
                    ], false),
                    shadowColor: 'rgba(144,195,30, 0.9)',
                    shadowBlur: 20
                }
              },
              data: obj.arr3,
            },
          ]
        };
        myChart.setOption(option);
    },
    hideTel(e){
      if(e != null && e != undefined){
        this.fnStopBub(e);
      }
      this.showD = false;

    },
    showTel(e){
      this.fnStopBub(e);
      this.showD = !this.showD
      //咨询数量+1
// companyReleaseInfo.companyInfo.companyOtherData.consultNum
    },
    /** 厂家环境图片预览 */
    showSwip() {
      this.showImall = true;
    },
    /** 厂家环境图片预览关闭 */
    close(e) {
      this.fnStopBub(e);
      this.showImall = false;
      if (e.toElement.nodeName == "DIV") this.showImall = false;
    },
    //切换二级目录明细
    showDetailTab(params,e){
      this.fnStopBub(e);
      this.checkDetailTitle = params;
      this.inEc()
      let obj = {
          id:"myChart",
          name:['综合产值规模评分' ,'人员结构管理评分' ,'物流管理能力评分' ,'业务资金健康评分' ,'生产管理能力评分'],
          arr:[30, 30, 30, 30, 30,30],
          arr1:[10, 16, 20, 15, 12,18],
          arr2:[5, 2, 10, 10, 10,15],
          arr3:[15, 22, 20, 20, 20,15]
      }
      let obj2 = {
          id:"myChart2",
          name:['平台订单交付时长评分' ,'客户服务能力评分' ,'平台企业受关注度' ,'平台售后服务质量评分' ,'平台服务区域范围评分' ,'平台产品方案热度'],
          arr:[30, 30, 30, 30, 30,30],
          arr1:[10, 16, 20, 15, 12,18],
          arr2:[5, 2, 10, 10, 10,15],
          arr3:[15, 22, 20, 20, 20,15]
      }
      let obj3 = {
          id:"myChartLine",
          name:['1K以下','1~2K','2~3K','3~5K','5~10K','10~20K','20~30K','30~40K','40K以上'],
          arr:[502.84, 205.97, 332.79, 281.55, 398.35, 214.02, 45,89,245],
          arr2:[181.55, 298.35, 314.02, 279.55, 189.57, 256.14,114.02, 45,89,245],
          arr3:[281.55, 398.35, 214.02, 179.55, 289.57, 356.14,214.02, 45,89,245]
      }
      if(params == 5){
        this.getEchartData(obj);
        this.getEchartDataline(obj3)
        this.getEchartDataTwo(obj2)
      }
    },
    //切换产品分类选项页
    showProdTypeTab(params,e){
      this.fnStopBub(e);
      this.checkSysProdType = params;
      this.fnLoadReleaseProdCase(2,e);
    },
    //切换厂家环境选项页
    showCjhjTypeTab(params,e){
      this.fnStopBub(e);
      this.checkCjhjType = params;
      this.companyReleaseInfo.companyReleaseDetail.cjhj.forEach((item, index) => {
			  if(item.introduceClassify == params){
          this.checkCjhj = this.companyReleaseInfo.companyReleaseDetail.cjhj[index];
        }
      })
    },

    /** 初始化企业发布信息主信息  头部+企业介绍+厂家环境+AI资质认证 */
    fnGetCompanyReleaseInfoMain(){
      let that = this;
      that.xmpcCpalSelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"companyId":this.companyId};
      that.xmgeBzjcpSelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"companyId":this.companyId};
      let param = {"companyId" : this.companyId, "companyReleaseDetail" : {"xmpcCpal": that.xmpcCpalSelObj, "xmgeBzjcp" : that.xmgeBzjcpSelObj}}
      requestByPost(API.selCompanyReleaseInfoFormEs,JSON.stringify(param)).then((res)=>{
        if(res.data != undefined && res.data.obj != undefined && res.data.obj != null ){
          that.companyReleaseInfo = res.data.obj;
          that.companyName = res.data.obj.companyInfo.companyName;
          that.releaseProdCaseList = res.data.obj.companyReleaseDetail.xmpcCpal.releaseProdCaseList;
          if(that.releaseProdCaseList.length == res.data.obj.companyReleaseDetail.xmpcCpal.page.total){
            that.canSelProdCase = false;
            that.loadProdCaseName = "~没有更多了~";
          }
          let xmgeBzjcp = that.companyReleaseInfo.companyReleaseDetail.xmgeBzjcp;
          if(xmgeBzjcp != null && xmgeBzjcp != undefined){
            that.twoProdTypeList = xmgeBzjcp.twoProdTypeList;
            that.threeProdTypeList =  xmgeBzjcp.threeProdTypeList;
            that.prodInfoList = xmgeBzjcp.prodInfoList;
          }
          let companyType = res.data.obj.companyInfo.companyType;//00001广告字招牌生产   00002标识导视生产   00003展示道具生产：展架    00004原材料耗材生产：云商    00005广告店铺：广告店铺
          that.companyType = companyType;
          res.data.obj.companyReleaseDetail.cjhj.forEach((item, index) => {
            if(index == 0){
              that.checkCjhj = item;
            }
          })
        }else{
          that.companyReleaseInfo = {};
          that.companyName = "";
          that.releaseProdCaseList = [];
          
          that.twoProdTypeList = [];
          that.threeProdTypeList =  [];
          that.prodInfoList = [];
          
        }
        //并且根据当前登录的userId，查询是否关联过这个企业，如果关联过，
        that.fnSelFollowCompanyByUserId();
        //根据当前登录的用户id 和 companyId 查询当前客户是否已经生成了改企业的客户信息，生成了不做处理，未生成，创建游客
        that.fnCheckCustInfoByCompanyIdAndUserId();
        //增加企业当前版本的点击数量
        that.fnUpdateHitsNum();
      })
    },
    /* 加载更多方案数据*/
    fnLoadReleaseProdCase(inType,e){
      this.fnStopBub(e);
      let that = this;
      if(inType == 2){
        that.canSelProdCase = true;
      }
      if(that.canSelProdCase){//说明还有更多的产品信息
         if(inType == 1){//分页查询
          let page = that.xmpcCpalSelObj.page;
          page.pageNum = Number(page.pageNum)+1;
          that.xmpcCpalSelObj.page = page;
        }else{
          that.releaseProdCaseList = [];
          let page = that.xmpcCpalSelObj.page;
          page.pageNum = 0;
          page.pageSize = that.pageSizeSel;
          that.xmpcCpalSelObj.page = page;
          that.xmpcCpalSelObj.selSysProdTypeId = that.checkSysProdType;
        }
        requestByPost(API.selReleaseProdCasePageFormEs,JSON.stringify(that.xmpcCpalSelObj)).then((res)=>{
          if(res.data.obj != null && res.data.obj.releaseProdCaseList != null &&  res.data.obj.releaseProdCaseList.length != 0){
            that.loadProdCaseName = "加载更多";
            that.canSelProdCase = true;
            let releaseProdCaseList = res.data.obj.releaseProdCaseList;
            releaseProdCaseList.forEach((item, index) => {
              that.releaseProdCaseList.push(item);
              if(that.releaseProdCaseList.length == res.data.obj.page.total){
                that.canSelProdCase = false;
                that.loadProdCaseName = "~没有更多了~";
              }
            })  
          }else{
            that.canSelProdCase = false;
            that.loadProdCaseName = "~没有更多了~";
          }
        })
      }else{
        //说明该条件下的产品已经全显示出来啦
         Toast('没有更多了')
      }
    },
     fnClickThreeProdType(prodTypeId,e){
       this.fnStopBub(e);
       this.checkThreeProdType =  prodTypeId;//所选择的标准件产品 分类id  第3级
       this.fnLoadProdInfo(2,null);
     },
    /* 加载更多 标准件产品 数据
    inType 1：分页查询进来   2：通过点击分类进来的
    */
    fnLoadProdInfo(inType,e){
      if(e != null && e != undefined){
        this.fnStopBub(e);
      }
      let that = this;
      if(that.canSelProdInfo){//说明还有更多的产品信息
        if(inType == 1){//分页查询
          let page = that.xmgeBzjcpSelObj.page;
          page.pageNum = Number(page.pageNum)+1;
          that.xmgeBzjcpSelObj.page = page;
        }else{
          that.prodInfoList = [];
          let page = that.xmgeBzjcpSelObj.page;
          page.pageNum = 0;
          page.pageSize = that.pageSizeSel;
          that.xmgeBzjcpSelObj.page = page;
          that.xmgeBzjcpSelObj.sysProdTypeId = that.checkOneProdType;
          that.xmgeBzjcpSelObj.parentProdTypeId = that.checkTwoProdType;
          that.xmgeBzjcpSelObj.prodTypeId = that.checkThreeProdType;
          // that.xmgeBzjcpSelObj.allProdTypeIds = that.checkOneProdType + ";"
        }
        
        requestByPost(API.selProdInfoPageFormEs,JSON.stringify(that.xmgeBzjcpSelObj)).then((res)=>{
          if(res.data != undefined && res.data != null && res.data.objs != undefined  && res.data.objs != null && res.data.objs.length != 0){
            that.loadProdInfoName = "加载更多";
            that.canSelProdInfo = true;
            let prodInfoList = res.data.objs;
            prodInfoList.forEach((item, index) => {
              that.prodInfoList.push(item);
            })
          }else{
            that.canSelProdInfo = false;
            that.loadProdInfoName = "~没有更多了~";
          }
        })
      }else{
        //说明该条件下的产品已经全显示出来啦
         Toast('没有更多了')
      }
    },
    /**通过行业分类，加载产品二级分类、三级分类 */
    fnChangeTwoAndThreeProdType(prodTypeId,level,e){
      this.fnStopBub(e);
      let that = this;
      if(level == 0){
        that.checkOneProdType = prodTypeId;//所选择的标准件产品 分类id  第1级
        that.checkTwoProdType = "-1";//所选择的标准件产品 分类id  第2级
        that.checkThreeProdType =  "-1";//所选择的标准件产品 分类id  第3级
      }else if(level == 1){
        that.checkTwoProdType = prodTypeId;//所选择的标准件产品 分类id  第2级
        that.checkThreeProdType =  "-1";//所选择的标准件产品 分类id  第3级
      }else if(level == 2){
        that.checkThreeProdType =  prodTypeId;//所选择的标准件产品 分类id  第3级
      }
      let obj = new Object();
      if(level == 0){
          obj.sysPid = prodTypeId;
      }else if(level == 1){
        obj.sysPid = that.checkOneProdType;
        obj.pid = prodTypeId;
      }
      obj.level = level;
      obj.companyId = that.companyId;
      requestByPost(API.selTwoAndThreeProdType,JSON.stringify(obj)).then((res)=>{
        if(level == 0){//说明点击的是行业分类
          that.twoProdTypeList = res.data.objs;
          console.log("二级分类："+JSON.stringify(res.data.objs));
        }
        that.threeProdTypeList = res.data.otherList;
        console.log("二级分类："+JSON.stringify(res.data.otherList));
        //根据条件加载产品信息
        that.fnLoadProdInfo(2,null);
      })
    },

    //企业介绍的 文本展开收起的显示控制
    fnShowOrHideText(showId,hideId,index,e){
      this.fnStopBub(e);
      document.getElementById(hideId+index).style.display="none";
      document.getElementById(showId+index).style.display="inline";
    },

    
    //跳转到案例详情页
    fnGotoCaseDetail(id,e){
      this.fnStopBub(e);
      this.$router.push({path: '/caseDetail', query: {projectId:id,inType:0}});
    },
    //关注该企业：必须先登录   type  0关注  1取消关注
    fnGotoFollowCompany(type,e){
      if(e != null && e != undefined){
        this.fnStopBub(e);
      }
      let that = this;
      if(that.fnCheckLogin()){
       //如果登录了，直接保存关注信息 、 取消关注信息
        let obj = new Object();
        obj.userId = that.userId;
        obj.companyId = that.companyId;
        obj.optType = type;
        obj.ccReleaseVersionId = that.companyReleaseInfo.id;//关注的版本id
        obj.id = (that.ucFollowCompany != null && that.ucFollowCompany.id != null && that.ucFollowCompany.id != undefined && that.ucFollowCompany.id != "") ? that.ucFollowCompany.id : null;
        requestByPost(API.saveOrDelUcFollowCompany,JSON.stringify(obj)).then((res)=>{
         Toast(res.data.retMsg);
          if(type == 0){
            this.isFollow = 1;
            that.ucFollowCompany = res.data.obj;
          }else{
            this.isFollow = 0;
            that.ucFollowCompany = null;
          }
        })
      }else{
        let optType = 2;//2关注  3取消关注
        if(type == 0){
          optType = 2;//2关注  3取消关注
        }else{
          optType = 3;//2关注  3取消关注
        }
        that.$router.push({path: '/login', query: {redirect_uri:'/companyDetails',state: that.companyId ,inType:optType}});
      }
    },
    inEc(){
      document.getElementById("myChart").style.width = document.body.clientWidth /2* 90 / 100 + 'px'
      document.getElementById("myChartLine").style.width = document.body.clientWidth  * 90 / 100 + 'px'
      document.getElementById("myChart2").style.width = document.body.clientWidth/2 * 90 / 100 + 'px'
    },
    //根据当前登录的用户id查询是否已经关注了该企业
    fnSelFollowCompanyByUserId(){
      let that = this;
      if(that.userId != null && that.userId != undefined && that.userId != ""){
        let obj = new Object();
        obj.userId = that.userId;
        obj.companyId = that.companyId;
        requestByPost(API.selByUserIdAndCompanyId,JSON.stringify(obj)).then((res)=>{
          that.ucFollowCompany = res.data.obj;
          if(res.data.obj != null && res.data.obj != undefined){
            that.isFollow = 1;
          }else{
            that.isFollow = 0;
          }


          //最后根据查询结果，看看是否直接执行关注。可能之前已经关注过了，就直接给提示即可
          var optType = that.$route.query.optType;
          if(that.ucFollowCompany == null && optType != null && optType != undefined && that.isFollow == 0){
            if(optType == 2){
              that.fnGotoFollowCompany(0,null);
            }
          }else if(optType != null && optType != undefined){
            Toast("已关注过该企业");
          }
        })
      }else{
        that.isFollow = 0;
      }
      
    },
    //根据当前登录的用户id 和 companyId 查询当前客户是否已经生成了改企业的客户信息，生成了不做处理，未生成，创建游客
    fnCheckCustInfoByCompanyIdAndUserId(){
      let that = this;
      if(that.userId != null && that.userId != undefined && that.userId != ""){
        let obj = new Object();
        obj.userId = that.userId;
        obj.companyId = that.companyId;
        obj.inTypeText = "企业主页进入";//进入方式文本描述，存到客户备注中： ***案例进入； 
        requestByPost(API.queryByUserIdAndCompanyId,JSON.stringify(obj)).then((res)=>{
          // alert(1);
        })
      }else{
        that.isFollow = 0;
      }
      
    },
    fnShowImall(e){
      this.fnStopBub(e);
      this.showImall = true;
    },
    //跳转到平台首页
    fnGoToHomePage(e){
       this.fnStopBub(e);
       this.$router.push({path: '/home'});
    },
    //跳转到找合作  搜索页直接查 2企业  、  1 产品
    fnGotoSearchPage(selType,e){
      this.fnStopBub(e);
      this.$router.push({path: '/search', query: {selType:selType}});
      
    },
    //更新当前版本的点击次数
    fnUpdateHitsNum(){
      let that = this;
      let obj = new Object();
      obj.hitsNum = 1;
      obj.id = that.companyReleaseInfo.id;//版本id;
      obj.companyId = that.companyReleaseInfo.companyId;
      requestByPost(API.fnUpdateHitsNum,JSON.stringify(obj)).then((res)=>{
        // alert(1);
      })
    }
  },
  mounted() {
    document.title = "企业主页";
  },
  created() {
    //用户信息
    var userInfo=this.$store.getters.getUserInfo
    if(userInfo!=null && userInfo.id!=null){
      this.userId = userInfo.id;
    }
    //企业id
    var companyId = this.$route.query.companyId;
    if(!_.isEmpty(companyId)){
      this.companyId = companyId;
    }
     //初始化头部信息 + 企业介绍 + 厂家环境 + AI资质认证
    this.fnGetCompanyReleaseInfoMain();
    
    
  },
};



// WEBPACK FOOTER //
// ./src/pages/company/companyDetails.vue